import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationType } from '../../core/enums/notification-type.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'notificationTypeName' })
export class NotificationTypeNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(type: NotificationType): string {
        switch (type) {
            case NotificationType.none: {
                return this.translateService.instant('All');
            }
            case NotificationType.mentionInNote: {
                return this.translateService.instant('Mention in note');
            }
            case NotificationType.answerToNote: {
                return this.translateService.instant('Answer to note');
            }
            case NotificationType.reply: {
                return this.translateService.instant('Reply');
            }
            case NotificationType.ticket: {
                return this.translateService.instant('Ticket');
            }
            case NotificationType.subReply: {
                return this.translateService.instant('Sub-reply');
            }
            case NotificationType.mentionInReply: {
                return this.translateService.instant('Mention in reply');
            }
            case NotificationType.ticketAssignment: {
                return this.translateService.instant('Ticket assignment');
            }
            case NotificationType.ticketReminder: {
                return this.translateService.instant('Reminder ended');
            }
            case NotificationType.ticketSurveyResponseAdded: {
                return this.translateService.instant('Ticket survey response added');
            }
            case NotificationType.emailDeliveryStatusUpdate: {
                return this.translateService.instant('Email delivery failed');
            }
            default:
                return '';
        }
    }
}
